<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('preInvoice.academic') }}</legend>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.mainProgram')
          }}</label>
          <div class="col-md-8">
            <input
              type="text"
              class="form-control-plaintext"
              readonly
              :value="
                studentInfo
                  ? studentInfo.academic_class.main_program.acp_name_foreign
                  : ''
              "
            />
            <div class="validate" v-if="errors.has('acp_id')">
              {{ errors.first('acp_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.subProgram')
          }}</label>
          <div class="col-md-8">
            <input
              type="text"
              class="form-control-plaintext"
              readonly
              :value="
                studentInfo
                  ? studentInfo.academic_class.sub_program.acps_name_foreign
                  : ''
              "
            />
            <div class="validate" v-if="errors.has('acps_id')">
              {{ errors.first('acps_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">
            {{ this.termOptions != null ? (this.termOptions[0]['ac_status_id'] == 1 ? 'Current Term/Semester' : 'New Term/Semester')  : 'Term/Semester' }}
          </label>
          <div class="col-md-8">
            <a-select v-model="model.ac_term_id" style="width: 100%" :options="termOptions" ></a-select>
            <div class="validate" v-if="errors.has('ac_term_id')">
              {{ errors.first('ac_term_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">
            {{
              $t('preInvoice.stopDateTerm')
            }}
          </label>
          <div class="col-md-8">
            <a-select
              v-model="model.term_stop"
              disabled
            ></a-select>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">
            {{ this.termOptions != null ? (this.gradeOptions[0].value == this.studentInfo.academic_class.grade.grade_id ? 'Current Grade' : 'New Grade') : 'Grade' }}
          </label>
          <div class="col-md-8">
            <a-select v-model="model.grade_id" style="width: 100%" :options="gradeOptions"></a-select>
            <div class="validate" v-if="errors.has('grade_id')">
              {{ errors.first('grade_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4">{{
            $t('preInvoice.remark')
          }}</label>
          <div class="col-md-8">
            <textarea class="form-control" rows="3" v-model="model.remark"></textarea>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'preInvoiceAcademic',
  props: ['value', 'studentInfo', 'validate'],
  data() {
    return {
      model: {},
      termOptions: null,
      gradeOptions: [],
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('preInvoice', ['preInvoiceFormView']),
    async fetchTerm(){
      if (this.studentInfo) {
            await this.preInvoiceFormView({
              number_of_term_per_grade: this.studentInfo.academic_class.sub_program.number_of_term_per_grade,
              term_order: this.studentInfo.academic_class.academic_term.term_order,
              end_date_of_term: this.studentInfo.academic_class.academic_term.term_stop,
              grade_id: this.studentInfo.academic_class.grade.grade_id,
              ac_year_id: this.studentInfo.academic_class.academic_year.ac_year_id,
              ac_term_id: this.studentInfo.academic_class.academic_term.ac_term_id,
              student_id: this.studentInfo.student_id,
              ac_status_id: this.studentInfo.ac_status_id,
              acps_id: this.studentInfo.academic_class.acps_id,
              next_grade_id: this.studentInfo.academic_class.grade.next_grade_id,
              fnName: 'acTerm',
            })
              .then((response) => {
                this.termOptions = response.acTerm
                .map(el => ({
                    value: el.ac_term_id,
                    label: el.batch_name ? `${el.term_name} - ${el.batch_name}` : el.term_name,
                    ac_status_id: el.ac_status_id,
                    term_order: el.term_order,
                    term_stop: el.term_stop
                  }))
                  this.model.ac_status_id = this.termOptions ? this.termOptions[0]['ac_status_id'] : ''
                  this.model.term_stop = this.termOptions ? this.termOptions[0]['term_stop'] : ''
              })
          }
    },
    async fetchGrade(){
      if (this.studentInfo) {      
          await this.preInvoiceFormView({
            number_of_term_per_grade: this.studentInfo.academic_class.sub_program.number_of_term_per_grade,
            term_order: this.studentInfo.academic_class.academic_term.term_order,
            end_date_of_term: this.studentInfo.academic_class.academic_term.term_stop,
            grade_id: this.studentInfo.academic_class.grade.grade_id,
            ac_year_id: this.studentInfo.academic_class.academic_year.ac_year_id,
            ac_term_id: this.studentInfo.academic_class.academic_term.ac_term_id,
            student_id: this.studentInfo.student_id,
            ac_status_id: this.studentInfo.ac_status_id,
            acps_id: this.studentInfo.academic_class.acps_id,
            next_grade_id: this.studentInfo.academic_class.grade.next_grade_id,
            fnName: 'grade',
          })
            .then((response) => {
              this.gradeOptions = response.grade
              .map(el => ({
                  value: el.grade_id,
                  label: el.grade_name_foreign
                }))
            })
        }
    }
  },
  watch: {
    studentInfo: function() {
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.termOptions = null
      this.gradeOptions = null
      this.fetchTerm()
      this.fetchGrade()
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
